import { render, staticRenderFns } from "./WhatsappSvg.vue?vue&type=template&id=c1946042"
import script from "./WhatsappSvg.vue?vue&type=script&lang=js"
export * from "./WhatsappSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports